import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import TitleBox from "../common/TitleBox";
import { HealthInfoButton } from "./HealthInfoButton";

const BodyInfoCard = ({ myinfo, handleToggle }) => {
  const navigate = useNavigate();
  const datas = [
    { id: 1, title: "Height", data: "height", unit: "cm" },
    { id: 2, title: "Weight", data: "weight", unit: "kg" },
    { id: 3, title: "Age", data: "age", unit: "years" },
    { id: 4, title: "Gender", data: "gender", unit: "" },
  ];
  const datas2 = [
    { id: 1, title: "Diagnosis", data: "cancerType" },
    { id: 2, title: "Stage", data: "cancerStaging" },
    { id: 3, title: "Treatment Stage", data: "anticancerTreatmentYN" },
    { id: 4, title: "Surgery Name", data: "operationName" },
    { id: 5, title: "Surgery Date", data: "operationDate" },
    { id: 6, title: "Treatment Type", data: "anticancerTreatmentType" },
  ];
  const data3 = [
    { id: 1, title: "Hospital", name: "hospitalName" },
    { id: 2, title: "Chronic Diseases", name: "chronicDisease" },
    { id: 3, title: "Medications", name: "medicineDrugs" },
  ];
  const ifLength6SLice = (stringdata) => {
    return stringdata?.length > 12
      ? stringdata?.slice(0, 12) + "..."
      : stringdata;
  };

  return (
    <div className="space-y-[28px] rounded-lg bg-green_10 p-6" id="health">
      <div onClick={handleToggle} className="flex flex-row items-center justify-between">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <div className="flex-shrink-0">
            <TitleBox option={1} title={"Physical & Medical Info"} />
          </div>
          <div className="px-3 py-1 text-base font-bold bg-white rounded-lg text-gray_140 flex-shrink-0">
            Edit
          </div>
        </div>
        <img
          alt={"arrowRight"}
          src="/images/mobile/icon/arrow_right.svg"
          className="transform rotate-90 flex-shrink-0"
        />
      </div>

      <div className="">
        <div className="pb-3 space-y-3 dashedBottom">
          {datas.map((data) => (
            <ul key={data.id} className="flex justify-between gap-3">
              <li className="w-[140px] flex-shrink-0 text-left text-body3_700 text-gray_160">
                {data.title}
              </li>
              <li className="flex-1 text-right text-body3_700 text-green_100 break-words">
                {data.data === "gender"
                  ? myinfo[data.data] === "M"
                    ? "Male"
                    : "Female"
                  : myinfo[data.data]}
                {data.unit}
              </li>
            </ul>
          ))}
        </div>
        <div className="pt-3 pb-6 space-y-3 dashedBottom">
          {datas2.map((data) => (
            <ul key={data.id} className="flex justify-between gap-3">
              <li className="w-[140px] flex-shrink-0 text-left text-body3_700 text-gray_160">
                {data.title}
              </li>
              <li className="flex-1 text-right text-body3_700 text-green_100 break-words">
                {data.data === "birth"
                  ? dayjs().format("YYYY") - myinfo[data.data]
                  : data.data === "gender"
                  ? myinfo[data.data] === "M"
                    ? "Male"
                    : "Female"
                  : data.data === "operationDate"
                  ? myinfo[data.data] === "OD997"
                    ? "Unknown"
                    : myinfo[data.data] !== undefined &&
                      dayjs(myinfo[data.data]).format("YYYY.MM.DD")
                  : myinfo[data.data]}
                {data.unit}
              </li>
            </ul>
          ))}
          <HealthInfoButton
            onClick={() => {
              navigate("/question/health", { state: { from: "healthInfo" } });
              // window.history.replaceState({ key: "value" }, "", "/healthinfo"); // /question/health 를 healthInfo로 변환해줌 결과페이지에서 뒤로가기시 설문조사 페이지로 다시 안가게끔함, 하지만 healthInfo가 두번 연속으로 있는 상태라 문제
            }}
            content={"Edit"}
            textColor={"text-green_120"}
            boxShadow={"0px 0px 5px #ABC8AF"}
          />
        </div>
        <div className="space-y-[28px] rounded-lg pt-6" id="disease">
          <TitleBox option={1} title={"Additional Medical Info"} />
          <div className="space-y-3">
            {data3.map((data) => (
              <ul key={data.id} className="flex justify-between gap-3 w-full">
                <li className="w-[140px] flex-shrink-0 text-left text-body3_700 text-gray_160">
                  {data.title}
                </li>
                <li className="flex-1 text-right text-body3_700 text-[#3651B4] break-words">
                  {myinfo[data.name]
                    ? data.name === "chronicDisease"
                      ? myinfo["chronicDisease"]?.map((el, idx) => (
                          <div key={idx}>{el + " "}</div>
                        ))
                      : data.name === "medicineDrugs"
                      ? myinfo["medicineDrugs"]?.map((el, idx) => (
                          <div key={idx}>
                            {ifLength6SLice(el) +
                              (idx + 1 === myinfo["medicineDrugs"]?.length
                                ? ""
                                : ", ")}
                          </div>
                        ))
                      : ifLength6SLice(myinfo[data.name])
                    : "-"}
                </li>
              </ul>
            ))}
          </div>
          <HealthInfoButton
            onClick={() =>
              navigate("/question/disease", { state: { from: "healthInfo" } })
            }
            content={"Edit"}
            textColor={"text-green_120"}
            boxShadow={"0px 0px 5px #ABC8AF"}
          />
        </div>
      </div>
    </div>
  );
};

export default BodyInfoCard;
